import { GenericoEnum } from './generico.enum';

export enum valorEnviarEmailEnum {
    PARA_UM = 1,
    PARA_TODOS = 2
}

export class EnviarEmailEnum {

    public static values = [
        { label: 'Selecione uma opção', value: null },
        { label: 'Para um', value: valorEnviarEmailEnum.PARA_UM },
        { label: 'Para todos', value: valorEnviarEmailEnum.PARA_TODOS  }
    ]

    public static getObjByValues(value: any) {
    return GenericoEnum.getObjByValues(value, EnviarEmailEnum.values);
}

    public static getDescricaoCompleta = (id: any) => {
    return GenericoEnum.getDescricaoCompleta(id, EnviarEmailEnum.values);
};

    public static getValue = (id: boolean) => {
    return GenericoEnum.getValue(id, EnviarEmailEnum.values);
}

    public static getNumberToBoolean = (valor: boolean): number => {
    if (valor  ===  true) {
        return 1;
    }
    return 0;
};

}





// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/dominios/enum/enviar-emails.enum.ts